export default __webpack_public_path__ + "static/job3-3486468c8b87bfdbcd32449cc64eaa55.jpg";